import * as yup from "yup";
export const StructureUtilizationSchema = yup.object().shape({
  projectName: yup.string().required("Required"),
  // lengthOfStru: yup.string().required("Required"),
  totalenHocky: yup.string().required("Required"),
  // widthOfStru: yup.string().required("Required"),
  totawidHocky: yup.string().required("Required"),
  sideHeight: yup.string(),
  centerHeight: yup.string(),
  bigColumnLoc: yup.string(),
  gutterNum: yup.string(),
  gutterLen: yup.string(),
  bigColImg: yup.string(),
  sideColImg: yup.string(),
  northSideHock: yup.string(),
  eastSideHock: yup.string(),
  westSideHock: yup.string(),
  southSideHock: yup.string(),
  hockeyToColoumnCount: yup.string(),
  lengthOfEntryCabin: yup.string(),
  widthOfEntryCabin: yup.string(),
  heightOfEntryCabin: yup.string(),
  entryCabinDirection: yup.string(),
  numOfDoorsEntryCabin: yup.string(),
  //   numOfDoorsSouth: yup.string(),
  //   numOfDoorsEast: yup.string(),
  //   numOfDoorsWest: yup.string(),
  //   sideFooterApronStatus: yup.string(),
  //   sideFooterApronStatusImg: yup.string(),
  //   sideinsectNetApronStatus: yup.string(),
  //   sideinsectNetApronImg: yup.string(),
  //   sidePolyfieldApronStatus: yup.string(),
  //   sidePolyfieldApronImg: yup.string(),

  sideFooterDirectionEast: yup.string(),
  sideFooterApronStatusEast: yup.string(),
  sideFooterApronStatusImgEast: yup.string(),

  sideFooterDirectionWest: yup.string(),
  sideFooterApronStatusWest: yup.string(),
  sideFooterApronStatusImgWest: yup.string(),

  sideFooterDirectionNorth: yup.string(),
  sideFooterApronStatusNorth: yup.string(),
  sideFooterApronStatusImgNorth: yup.string(),

  sideFooterDirectionSouth: yup.string(),
  sideFooterApronStatusSouth: yup.string(),
  sideFooterApronStatusImgSouth: yup.string(),

  sideinsectNetDirectionEast: yup.string(),
  sideinsectNetApronStatusEast: yup.string(),
  sideinsectNetApronStatusImgEast: yup.string(),

  sideinsectNetDirectionWest: yup.string(),
  sideinsectNetApronStatusWest: yup.string(),
  sideinsectNetApronStatusImgWest: yup.string(),

  sideinsectNetDirectionNorth: yup.string(),
  sideinsectNetApronStatusNorth: yup.string(),
  sideinsectNetApronStatusImgNorth: yup.string(),

  sideinsectNetDirectionSouth: yup.string(),
  sideinsectNetApronStatusSouth: yup.string(),
  sideinsectNetApronStatusImgSouth: yup.string(),

  sidePolyfieldDirectionEast: yup.string(),
  sidePolyfieldApronStatusEast: yup.string(),
  sidePolyfieldApronImgEast: yup.string(),

  sidePolyfieldDirectionWest: yup.string(),
  sidePolyfieldApronStatusWest: yup.string(),
  sidePolyfieldApronImgWest: yup.string(),

  sidePolyfieldDirectionNorth: yup.string(),
  sidePolyfieldApronStatusNorth: yup.string(),
  sidePolyfieldApronImgNorth: yup.string(),

  sidePolyfieldDirectionSouth: yup.string(),
  sidePolyfieldApronStatusSouth: yup.string(),
  sidePolyfieldApronImgSouth: yup.string(),

  secoundaryShadowNet: yup.string(),
  secoundaryShadowNetImg: yup.string(),
  docpolyfilmStatus: yup.string(),
  docpolyfilmImg: yup.string(),
  universalJoin: yup.string(),
  notes: yup.string(),
});
